import React from 'react';
import IconWrapper from '../IconWrapper';
const PlusWithBackgorundIcon = (props) => (React.createElement(IconWrapper, Object.assign({ viewBox: "1 1 24 24" }, props),
    React.createElement("circle", { cx: "13", cy: "13", r: "11", fill: "#E4E4E4", stroke: "#fff", strokeWidth: "2" }),
    React.createElement("path", { d: "M13 9v4m0 4v-4m0 0H9h8", stroke: "#000" })));
export default PlusWithBackgorundIcon;
//# sourceMappingURL=PlusWithBackgroundIcon.js.map